module.exports = __webpack_public_path__ + "static/media/deleteService.cf7170ca.png";